import React from 'react';
import Head from 'next/head';
import PageLayout from '../layouts/page';
import SignUpYear from '../components/YearSignUp';
import { ADDRESS_BOOKS } from 'day8-react/build/new-components';

const SignUp2025 = () => (
  <PageLayout page={{ seo_title: 'Sign Up 2026 | The Ski Week' }} hiddenCurrency signupHidden>
    <Head>
      <title>Sign Up 2026</title>
    </Head>
    <div className="tsw-c-intro position-relative margin-bottom-xl">
      <div className="text-center">
        <div className="intro-bg d8-u-bg-img width-100% position-absolute" style={{ backgroundImage: 'url(https://assets.theskiweek.com/wp-content/uploads/2021/06/bg1.jpg)', height: '70%', backgroundPosition: 'bottom center' }} />
        <div className="padding-top-xl">
          <SignUpYear year="2026" addressBookId={ADDRESS_BOOKS['tsw-signup-2025']} />
        </div>
      </div>
    </div>
  </PageLayout>
);

export default SignUp2025;
